import React, {useContext, useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types'
import {AccordionWrapperContext} from "../../contexts/contexts";

const AccordionTemplate = (props) => {
  const {children, contractFromChildren, isOpen, index} = props
  // Context para obtener el acordeon activo en un sistema de acordeon
  const {currentAccordionActive, setCurrentAccordionActive} = useContext(AccordionWrapperContext)
  // Valida si el acordión se encuentra en un context
  const isAccordionContext = currentAccordionActive !== null
  // Valida si es el acordeon activo en el context
  const isCurrent = currentAccordionActive === index

  // Contenedor referencia que usaremos para conseguir la altura
  const container = useRef()
  const [height, setHeight] = useState(0)
  const [expanded, setExpanded] = useState(isOpen || isCurrent)

  // Función para obtener la altura del contenedor a ocultar
  const getContainerHeight = () => {
    if (container.current) {
      setHeight(Math.round(container.current.getBoundingClientRect().height))
    }
  }

  // Función para abrir y cerrar el acordeón
  const handleExpand = () => setExpanded(!expanded)

  const handleExpandContext = () => {
    if (index === currentAccordionActive) handleExpand()
    else {
      setExpanded(true)
      setCurrentAccordionActive(index)
    }
  }

  useEffect(getContainerHeight, [height])

  // Escucha si un acordión dentro de un context se abre, para así cerrarse
  useEffect(() => {
    if (isAccordionContext) {
      if (index !== currentAccordionActive) setExpanded(false)
    }
  }, [currentAccordionActive])

  return (
    <>
      {/* En el primer contenedor irán los elementos que se usarán como trigger para activar el acordeón*/}
      <div
        onClick={isAccordionContext ? handleExpandContext : handleExpand}
        className={`accordion-trigger ${expanded && 'expanded'}`}
      >
        {children[0]}
      </div>
      {/*  En el segundo contenedor irán los elementos que se quieren ocultar */}
      <div
        className="accordion-container s-overflow-hidden height-transition"
        // Si el acordeón está expandido poner la altura que obtuvimos, si no dejarlo en 0 para ocultar los elementos
        style={{height: expanded ? `${height}px` : '0'}}
      >
        <div ref={container}
          onClick={contractFromChildren ? handleExpand : null}>
          {children[1]}
        </div>
      </div>
    </>
  )
};

AccordionTemplate.propTypes = {
  index: PropTypes.number,
  children: PropTypes.node.isRequired,
  contractFromChildren: PropTypes.bool,
  isOpen: PropTypes.bool,
}

AccordionTemplate.defaultProps = {
  index: null,
  contractFromChildren: false,
  isOpen: false,
}

export default AccordionTemplate;
